
<v-card class="v-flex p-0" flat style="border-radius: unset; position: relative" @click="onClick"  >
    <div class="measure-name secondary white--text">
        <div>{{ name }}</div>
        <div v-if="hint" class="measure-hint">{{ hint }}</div>
    </div>
    <div class="measure-value secondary lighten-4 secondary--text">
        {{ measure }}
    </div>
</v-card>
